var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRevenueSharing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_107_51549)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 60,
    height: 60,
    rx: 8,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_107_51549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0044 20.3566C33.0403 20.3566 29.2878 25.8551 29.2878 29.224V29.5247C29.2849 31.2825 29.2827 32.6707 30.159 33.5382C31.0559 34.4263 32.9684 34.8575 36.0051 34.8575C42.941 34.8575 42.941 32.857 42.941 29.2248C42.9403 25.8888 39.5809 20.3566 36.0044 20.3566Z",
    fill: "#1C74D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5495 31C36.4775 31 36.4204 30.9857 36.3784 30.9571C36.3363 30.9286 36.2973 30.8943 36.2613 30.8543L34.1982 28.6086C34.1502 28.5629 34.1171 28.5229 34.0991 28.4886C34.0871 28.4486 34.0811 28.3886 34.0811 28.3086V28.12C34.0811 28.0629 34.0991 28.0171 34.1351 27.9829C34.1772 27.9429 34.2282 27.9229 34.2883 27.9229H34.7748C35.1952 27.9229 35.5165 27.8714 35.7387 27.7686C35.961 27.6657 36.1111 27.5286 36.1892 27.3571C36.2733 27.1857 36.3153 26.9886 36.3153 26.7657C36.3153 26.5543 36.2733 26.3629 36.1892 26.1914C36.1111 26.0143 35.967 25.8743 35.7568 25.7714C35.5465 25.6686 35.2492 25.6171 34.8649 25.6171H34.2072C34.1471 25.6171 34.0961 25.6 34.0541 25.5657C34.018 25.5257 34 25.4771 34 25.42V25.1971C34 25.14 34.018 25.0943 34.0541 25.06C34.0961 25.02 34.1471 25 34.2072 25H37.7928C37.8529 25 37.9009 25.02 37.9369 25.06C37.979 25.0943 38 25.14 38 25.1971V25.42C38 25.4771 37.979 25.5257 37.9369 25.5657C37.9009 25.6 37.8529 25.6171 37.7928 25.6171H36.4234L36.1982 25.3857C36.5886 25.4771 36.8559 25.6514 37 25.9086C37.1441 26.1657 37.2162 26.4629 37.2162 26.8C37.2162 27.1143 37.1441 27.4029 37 27.6657C36.8619 27.9286 36.6396 28.14 36.3333 28.3C36.033 28.4543 35.6456 28.5371 35.1712 28.5486L34.9009 28.5571L34.9099 28.2143L37.2162 30.7343C37.2643 30.78 37.2883 30.8229 37.2883 30.8629C37.2883 30.9086 37.2703 30.9429 37.2342 30.9657C37.1982 30.9886 37.1532 31 37.0991 31H36.5495ZM34.2072 26.9886C34.1411 26.9886 34.0901 26.9714 34.0541 26.9371C34.018 26.9029 34 26.8543 34 26.7914V26.5771C34 26.5143 34.018 26.4657 34.0541 26.4314C34.0961 26.3971 34.1471 26.38 34.2072 26.38H37.7928C37.8529 26.38 37.9009 26.3971 37.9369 26.4314C37.979 26.4657 38 26.5143 38 26.5771V26.7914C38 26.8543 37.979 26.9029 37.9369 26.9371C37.9009 26.9714 37.8529 26.9886 37.7928 26.9886H34.2072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3057 14.1973C41.2698 14.0792 41.181 14.0264 41.0556 14.0227C40.7946 14.0139 40.2218 14.2743 39.6586 15.2951C39.6418 15.3259 39.6227 15.3545 39.6 15.3838C38.962 16.2103 38.2477 16.563 37.4586 16.4281C36.9695 16.3907 36.5046 16.123 36.0763 15.6324L35.9487 15.4865L35.8204 15.6324C35.3796 16.1311 34.9037 16.3951 34.3537 16.4391C33.6497 16.5351 32.8892 16.0841 32.3796 15.2584C31.9249 14.4686 31.3954 14 30.9606 14C30.852 14 30.775 14.0667 30.7684 14.1628C30.7083 14.9101 31.7716 17.6835 33.1943 19.6885L33.2816 19.8109L33.4143 19.7398C35.1464 18.8121 36.8199 18.7799 38.6774 19.6401L38.805 19.6987L38.8864 19.5858C40.3795 17.5317 41.434 14.8155 41.3057 14.1973Z",
    fill: "#1C74D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 44.0946H25.6864V41.4421C25.6864 38.2594 23.0655 35.67 19.8432 35.67C16.6209 35.67 14 38.2587 14 41.4421V44.0946Z",
    fill: "#1C74D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8432 27.2609C17.9109 27.2609 16.3386 28.8141 16.3386 30.7237C16.3386 32.6333 17.9109 34.185 19.8432 34.185C21.7756 34.185 23.3478 32.6325 23.3478 30.7237C23.3478 28.8148 21.7763 27.2609 19.8432 27.2609Z",
    fill: "#1C74D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3136 44.0946H58V41.4421C58 38.2594 55.3791 35.67 52.1568 35.67C48.9345 35.67 46.3136 38.2587 46.3136 41.4421V44.0946Z",
    fill: "#1C74D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1568 27.2609C50.2245 27.2609 48.6522 28.8141 48.6522 30.7237C48.6522 32.6333 50.2245 34.185 52.1568 34.185C54.0892 34.185 55.6614 32.6325 55.6614 30.7237C55.6614 28.8148 54.0899 27.2609 52.1568 27.2609Z",
    fill: "#1C74D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2705 58H41.9569V55.3475C41.9569 52.1648 39.336 49.5754 36.1137 49.5754C32.8914 49.5754 30.2705 52.1641 30.2705 55.3475V58Z",
    fill: "#1C74D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1136 41.1671C34.1813 41.1671 32.609 42.7203 32.609 44.6299C32.609 46.5388 34.1813 48.0912 36.1136 48.0912C38.0459 48.0912 39.6182 46.5388 39.6182 44.6299C39.6182 42.7203 38.0459 41.1671 36.1136 41.1671Z",
    fill: "#1C74D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.083 38.4273C45.196 38.0181 44.9723 37.5905 44.5712 37.449L40.8605 36.1371C40.4799 36.0029 40.0634 36.1972 39.9277 36.5719C39.792 36.9467 39.9886 37.3588 40.3677 37.4937L43.9926 38.9633C44.4436 39.1459 44.954 38.8951 45.083 38.4273Z",
    fill: "#1C74D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.296 36.4899C32.1545 36.1181 31.7328 35.9289 31.3573 36.0675L27.7567 37.2885C27.3717 37.4191 27.1553 37.8261 27.2631 38.2169C27.3819 38.6496 27.8469 38.8879 28.2693 38.7332L31.8685 37.4169C32.2461 37.2783 32.4375 36.8625 32.296 36.4899Z",
    fill: "#1C74D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0858 39.3067C35.6949 39.3067 35.3715 39.0009 35.3576 38.6122L35.3077 37.2372C35.2938 36.839 35.6076 36.5053 36.0102 36.4914C36.4275 36.4577 36.7502 36.7884 36.7648 37.1851L36.8147 38.5601C36.8286 38.9583 36.5148 39.292 36.1122 39.3059C36.1034 39.3067 36.0946 39.3067 36.0858 39.3067Z",
    fill: "#1C74D0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_107_51549",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_107_51549"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_107_51549",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_107_51549"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenueSharing);
export default __webpack_public_path__ + "static/media/revenueSharing.c85f2668c4c2664d80c4f5c36718ad3f.svg";
export { ForwardRef as ReactComponent };